/**
 * @generated SignedSource<<fcc58edee9101f4ee1a46b5d33560408>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ItemList_component$data = {
  readonly entries: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"ItemListEntry_component">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly smalllabel: string | null | undefined;
  readonly " $fragmentType": "ItemList_component";
};
export type ItemList_component$key = {
  readonly " $data"?: ItemList_component$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemList_component">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemList_component",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000
        }
      ],
      "concreteType": "ItemListEntryConnection",
      "kind": "LinkedField",
      "name": "entries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemListEntryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ItemListEntry",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ItemListEntry_component"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "entries(first:1000)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smalllabel",
      "storageKey": null
    }
  ],
  "type": "ItemList",
  "abstractKey": null
};

(node as any).hash = "58fff63ae04867c8bf64c1c9fb68ad96";

export default node;
